import React from "react";
import ProtectedRoute from "../../components/ProtectedRoute";
import AdminContro from "../AuthCustom/AdminContro";

// This wrapper ensures AdminContro is only accessible to authenticated users (superadmin)
const AdminControProtected = () => {
  return (
    <ProtectedRoute>
      <AdminContro />
    </ProtectedRoute>
  );
};

export default AdminControProtected;
